<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    Souscriptions expirant dans 1 mois
                </div>
                <div class="card-body">
                    <data-table
                        :data="[]"
                        :headers="columns"
                        :customizeTable="{
                            labelLoading: 'Chargement...',
                            labelDetails: ''
                        }"
                        :loading="false"
                    >
                    <template #withPagination>
                        <with-pagination
                            @previous="previous()"
                            @next="next()"
                            :links="subscriptions.links"
                        />
                    </template>
                    <template #withBody>
                        <tr v-for="(item, i) in subscriptions.data" :key="i">
                            <td>{{ item.last_name }}</td>
                            <td>{{ item.first_name }}</td>
                            <td>{{ item.product }}</td>
                            <td>{{ item.expired_at }}</td>
                            <td>
                                <span class="badge badge-pill badge-danger">Arrive à terme</span>
                            </td>
                        </tr>
                    </template>
                    </data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataTable from '../../components/customTable/dataTable.vue'
import WithPagination from '../../components/customTable/elements/withPagination.vue'
    export default {
  components: { dataTable, WithPagination },
        name: "subscription",
        props: ["subscriptions"],
        data: () => ({
            columns: [
                {title: 'Nom', key: 'last_name'},
                {title: 'Prénom(s)', key: 'first_name'},
                {title: 'Souscription', key: 'product'},
                {title: 'date d\'expiration', key: 'expired_at'},
                {title: 'statut', key: 'status'},
            ],
        }),
        methods:{
            previous(){

            },
            next(){

            }
        }
    }
</script>

<style scoped>

</style>
